import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "not-exported-order" }
const _hoisted_2 = { class: "not-exported-order__title not-exported-order-title" }
const _hoisted_3 = { class: "not-exported-order-title__label" }
const _hoisted_4 = { class: "not-exported-order-title__not-export-order not-export-order" }
const _hoisted_5 = { class: "not-exported-order__main-contents not-exported-order-main-contents" }
const _hoisted_6 = { class: "not-exported-order-main-contents__top-accessory top-accessory" }
const _hoisted_7 = { class: "top-accessory__left" }

import TextButton from '@/components/input/Btn/TextButton.vue';
import Pagination from '@/corePagesModule/components/Pagination.vue';
import { i18n } from '@/i18n';
import SvgLoader from '@/utils/SvgLoader.vue';
import NewBaseTableContent from '@/corePagesModule/BaseTableContent/NewBaseTableContent.vue';
import { useNotExportedOrderStore } from './useNotExportedOrderStore';
import { storeToRefs } from 'pinia';
import { onMounted } from 'vue';
import ExportOrderModal from '../components/exportModal/ExportOrderModal.vue';
import FilterModalButton from '@/corePagesModule/filterModal/FilterModalButton.vue';
import { isLoading } from '@/coreDomainsModule/uiLoadingState';
import InfoModal from '@/corePagesModule/components/InfoModal.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'main',
  setup(__props) {

const notExportedOrderStore = useNotExportedOrderStore();
const { state } = storeToRefs(notExportedOrderStore);
const {
  init,
  onChangePaging,
  sortTableContentItems,
  onAppliedFilterModal,
  onClosedExportModal,
  updateMemo,
  deleteMemo,
  getFilterItemsValue,
} = notExportedOrderStore;
const t = i18n.t;
let renderingKey = 0; // 同期的にテーブルを再描画するためのkey

onMounted(async () => {
  await init();
  renderingKey += 1;
});

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)('未出力の発注')), 1),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_RouterLink, {
          class: "not-export-order__label",
          to: "/firm-order"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('発注の進捗確認ページに切り替え')), 1)
          ], undefined, true),
          _: 1
        }),
        _createVNode(SvgLoader, {
          class: "not-export-order__icon",
          name: "orderSwitchIcon"
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(FilterModalButton, {
            class: "detail-filter-modal",
            "filter-modal-type": 'order',
            "select-input-index": 0,
            "filter-items": _unref(getFilterItemsValue)().value,
            onApply: _cache[0] || (_cache[0] = (filteredContents) => _unref(onAppliedFilterModal)(filteredContents))
          }, null, 8, ["filter-items"]),
          _createVNode(TextButton, {
            "button-style": 'btn-primary',
            size: 'btn-md',
            "on-click": 
              () => {
                _unref(state).exportModalState = true;
              }
            ,
            disabled: _unref(state).checkedIds.length === 0,
            class: "export-order-button"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('発注を出力')), 1)
            ], undefined, true),
            _: 1
          }, 8, ["on-click", "disabled"])
        ]),
        (_unref(state).pagingOptions)
          ? (_openBlock(), _createBlock(Pagination, {
              key: 0,
              "paging-options": _unref(state).pagingOptions,
              "is-loading": _unref(state).loadingState.status.type === 'loading',
              "is-order-page": "",
              class: "pagination",
              onOnChangePage: _cache[1] || (_cache[1] = ($event: any) => (_unref(onChangePaging)($event)))
            }, null, 8, ["paging-options", "is-loading"]))
          : _createCommentVNode("", true)
      ]),
      (_openBlock(), _createBlock(NewBaseTableContent, {
        key: _unref(renderingKey),
        "prop-table-content-properties": _unref(state).tableContentProperties,
        "prop-display-objects": _unref(state).tableContentItems,
        "prop-loading-status": _unref(state).loadingState,
        "prop-table-type": 'notExportedOrderTable',
        class: "not-exported-order-main-contents__table",
        onChecked: _cache[2] || (_cache[2] = ($event: any) => (_unref(state).checkedIds = $event)),
        onOnClickSort: _cache[3] || (_cache[3] = (sortKey) => _unref(sortTableContentItems)(sortKey)),
        onOnClickSaveMemo: _cache[4] || (_cache[4] = (orderId, memo) => _unref(updateMemo)(orderId, memo)),
        onOnClickDeleteMemo: _cache[5] || (_cache[5] = (orderId) => _unref(deleteMemo)(orderId))
      }, null, 8, ["prop-table-content-properties", "prop-display-objects", "prop-loading-status"]))
    ]),
    _createVNode(ExportOrderModal, {
      "modal-state": _unref(state).exportModalState,
      onCloseModal: _cache[6] || (_cache[6] = ($event: any) => (_unref(state).exportModalState = false)),
      onExportOrder: _cache[7] || (_cache[7] = ($event: any) => (_unref(onClosedExportModal)($event)))
    }, null, 8, ["modal-state"]),
    _createVNode(InfoModal, {
      "modal-state": _unref(isLoading)(_unref(state).updateMemoState.loading.status),
      icon: "loading",
      "enable-outside-click": false
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(state).updateMemoState.workType === 'delete' ? _unref(t)('メモを削除しています') : _unref(t)('メモを保存しています')), 1)
      ]),
      _: 1
    }, 8, ["modal-state"])
  ]))
}
}

})